import { ApiModule } from '~/clientApi/ApiModule';

const benchmarks = (apiInstance) => new ApiModule(apiInstance, 'benchmarks');

export default benchmarks;
